module.exports = __webpack_public_path__ + "img/he2.4d3795f8.png";